import { server } from '../server';
export const uploadImage = async (walletAddress, file) => {
    if (!file.type.startsWith('image/')) {
        throw new Error('The provided file is not an image');
    }
    const formData = new FormData();
    formData.append('file', file);
    const response = await server.post({ endpoint: 'image/upload' }, {
        body: formData,
        needAuthentication: true,
        walletAddress,
    });
    if (!response.ok) {
        throw new Error(`Error uploading image: ${response.statusText}`);
    }
    const imageUrl = await response.text();
    return imageUrl;
};
